import { motion } from "framer-motion";
import { ArrowUpRight, Flame } from "lucide-react";
import { useStore } from "../context/StoreContext";

const CARDS = [
  {
    title: "Corrida",
    tag: "Categoria 01",
    desc: "Performance e fôlego para quem corre todos os dias.",
    img: "https://images.unsplash.com/photo-1758506971986-b0d0edebd8d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxtYXJhdGhvbiUyMHJ1bm5lciUyMHJ1bm5pbmclMjBzaG9lcyUyMHVyYmFuJTIwZml0bmVzc3xlbnwwfHx8fDE3OTEzMjgwMTV8MA&ixlib=rb-4.1.0&q=85",
    cls: "md:col-span-2 md:row-span-2 min-h-[420px]",
    category: "Corrida",
  },
  {
    title: "Sneakers",
    tag: "Categoria 02",
    desc: "Os pares que dominam as ruas e os feeds.",
    img: "https://images.unsplash.com/photo-1609521181575-55ee33fb66d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY6OTV8MHwxfHNlYXJjaHwyfHx0cmF2aXMlMjBzY290dCUyMHBvcnRyYWl0JTIwY29uY2VydCUyMHJhcHBlcnxlbnwwfHx8fDE3OTEzMzA0MDV8MA&ixlib=rb-4.1.0&q=85",
    cls: "md:row-span-2 min-h-[300px]",
    live: true,
    category: "Sneakers",
  },
  {
    title: "Edições Limitadas",
    tag: "Categoria 03",
    desc: "Drops numerados que não voltam. Quando acaba, acabou.",
    img: "https://images.unsplash.com/photo-1778787827063-403bc85987cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxzdHJlZXR3ZWFyJTIwZmFzaGlvbiUyMHNuZWFrZXIlMjB1cmJhbiUyMGxpZmVzdHlsZSUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzkxMjQzMDMzfDA&ixlib=rb-4.1.0&q=85",
    cls: "md:col-span-3 min-h-[240px]",
    category: "Edição Limitada",
  },
];

export function BentoGrid() {
  const { goToCategory } = useStore();
  return (
    <section id="categorias" className="bg-white py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="mb-12 flex flex-wrap items-end justify-between gap-4"
        >
          <h2 className="font-display text-4xl font-black uppercase leading-none tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
            Categorias em <span className="text-vult-red">destaque</span>
          </h2>
          <p className="font-mono text-xs font-bold uppercase tracking-widest text-slate-500">Escolha seu território</p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {CARDS.map((c, i) => (
            <motion.a
              key={c.title}
              href="#catalogo"
              data-testid={`vult-bento-card-${c.title.toLowerCase().replace(/\s/g, "-")}`}
              onClick={(e) => { if (c.category) { e.preventDefault(); goToCategory(c.category); } }}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className={`group relative overflow-hidden rounded-3xl bg-slate-900 ${c.cls}`}
            >
              <img
                src={c.img}
                alt={c.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/20 to-transparent" />
              {c.live && (
                <span className="absolute right-4 top-4 flex items-center gap-1.5 rounded-full bg-vult-red px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-widest text-slate-900">
                  <Flame size={11} /> Estoque acabando
                </span>
              )}
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-6">
                <div>
                  <div className="mb-2 font-mono text-[10px] font-bold uppercase tracking-widest text-vult-lime">{c.tag}</div>
                  <div className="font-display text-2xl font-black uppercase leading-none text-white sm:text-3xl">{c.title}</div>
                  <div className="mt-1 text-sm text-slate-300">{c.desc}</div>
                </div>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-slate-900 transition-all duration-300 group-hover:bg-vult-red group-hover:text-slate-900 group-hover:rotate-45">
                  <ArrowUpRight size={18} />
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
